import { Button } from "components/Button/Button";
import { IconCollection } from "components/Icon/IconCollection";
import { Popover } from "components/Popover/Popover";
import { ActionToolbarProps } from "containers/Resources/components/CommonActions/ActionToolbar";
import {
    DeleteListAction,
    PermanentlyDeleteListAction,
    RemoveIdentityListAction,
    RemoveRelationshipListAction,
    UndeleteListAction,
} from "containers/Resources/components/CommonActions/CommonActions";

type ToolbarProps<T> = Pick<
    ActionToolbarProps<T>,
    "selectedItems" | "afterButtonAction" | "isDisabled" | "actionButtonLabel"
>;

export const RelationshipRecordToolbar = <T extends object>({
    selectedItems,
    afterButtonAction,
    isDisabled,
    actionButtonLabel,
}: ToolbarProps<T>) => (
    <RemoveRelationshipListAction
        resources={selectedItems}
        afterAction={afterButtonAction}
        isDisabled={isDisabled}
        actionButtonLabel={actionButtonLabel}
    />
);

export const RoleIdentityToolbar = <T extends object>({
    selectedItems,
    afterButtonAction,
}: ToolbarProps<T>) => (
    <RemoveIdentityListAction resources={selectedItems} afterAction={afterButtonAction} />
);

export const CustomObjectListToolbar = <T extends object>({
    selectedItems,
    afterButtonAction,
}: ActionToolbarProps<T>) => {
    return (
        <>
            <DeleteListAction resources={selectedItems} afterAction={afterButtonAction} />
            <Popover
                anchorOrigin={{
                    vertical: 10,
                    horizontal: 10,
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                trigger={<Button icon={IconCollection.dotsHorizontal} variation="clear" label="" />}
            >
                <ul className="popoverMenu">
                    <li>
                        <UndeleteListAction
                            resources={selectedItems}
                            afterAction={afterButtonAction}
                        />
                    </li>
                    <li>
                        <PermanentlyDeleteListAction
                            resources={selectedItems}
                            afterAction={afterButtonAction}
                        />
                    </li>
                </ul>
            </Popover>
        </>
    );
};
